import { Modal, Button } from "react-bootstrap";
import { FaTrash } from "react-icons/fa";

export default function DeleteModal({
show,
handleClose,
confirmDelete
}){

return(

<Modal show={show} onHide={handleClose} centered>

<Modal.Body className="text-center">

<FaTrash size={40} color="red"/>

<h4 className="mt-3">Confirm Delete</h4>

<p>
You want to delete this project. This cannot be undone.
</p>

<div className="d-flex justify-content-center">

<Button
variant="light"
className="me-3"
onClick={handleClose}
>
Cancel
</Button>

<Button
variant="danger"
onClick={confirmDelete}
>
Yes Delete
</Button>

</div>

</Modal.Body>

</Modal>

)

}